<template>
  <div>
    <h1>Dashboard Warehouse</h1>
  </div>
</template>
<script>
export default {
  name: "DashboardAdmin",
};
</script>
